module.exports = __webpack_public_path__ + "assets/img/pa-top.693dd60a.png";